import { Link } from 'react-router-dom';
import { DistributiveOmit } from '@mui/types';

import { CoreButton, CoreButtonProps } from '@youscience/core';

export interface CoreLinkButtonProps extends DistributiveOmit<CoreButtonProps, 'component' | 'to'> {
  to: string;
  state?: unknown;
}

export const CoreLinkButton = ({ children, to, state, ...rest }: CoreLinkButtonProps) => {
  const linkProps = { state };

  return (
    <CoreButton component={Link} to={to} {...linkProps} {...rest}>
      {children}
    </CoreButton>
  );
};
